// TODO: review 'ObjectUtils' import. starting primeng v8+ it might have changed to primeng/utils
import { Injectable } from '@angular/core';
import { Table } from 'primeng/table';
import { CreateNumericLabelPipe } from '../../../shared/pipes/create-numeric-label.pipe';
import { DateTimeFormatterPipe } from '../../../shared/pipes/date-time-formatter.pipe';

@Injectable({
  providedIn: 'root',
})
export class CustomTableFiltersService {
  constructor(private dateTimeFormatterPipe: DateTimeFormatterPipe, private createNumericLabelPipe: CreateNumericLabelPipe) { }

  private tables: Map<string, Table> = new Map();

  public addCustomFilters(table: Table, tableWrapperId: string): void {
    this.addFormattedDateFilter(table);
    this.addFormattedNumericFilter(table);
    if (tableWrapperId) {
      this.tables.set(tableWrapperId, table);
    }
  }

  public removeFilters(tableWrapperId: string): void {
    const table = this.tables.get(tableWrapperId);
    if (table) {
      table.clear();
    } else {
      console.error(`CustomTableFiltersService: Failed to find table with id '${tableWrapperId}' for removing filters.`);
    }
  }

  private addFormattedDateFilter(table: Table): void {
    // TODO: review if this works after primeng version upgrade to v8+. Might need to use 'FilterUtils' that been added in later versions
    // Filter based on 'contains' filter from primeng v7.1.3
    // Permalink: https://github.com/primefaces/primeng/blob/77d1b32d7cb32ceea6a9e6bdf32da7cc9262ae91/src/app/components/table/table.ts#L1307
    if (table !== undefined) {
      // table.filterConstraints[CustomTableFilterMatchers.FormattedDateMatcher] = (value, filter): boolean => {
      //   if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
      //     return true;
      //   }

      //   if (value === undefined || value === null) {
      //     return false;
      //   }

      //   const cellValue = this.dateTimeFormatterPipe.transform(value);
      //   const filterValue = this.dateTimeFormatterPipe.transform(filter);

      //   return cellValue === filterValue;
      // };
    }
  }

  private addFormattedNumericFilter(table: Table): void {
    // TODO: review if this works after primeng version upgrade to v8+. Might need to use 'FilterUtils' that been added in later versions
    // Filter based on 'startsWith' filter from primeng v7.1.3
    // Permalink: https://github.com/primefaces/primeng/blob/77d1b32d7cb32ceea6a9e6bdf32da7cc9262ae91/src/app/components/table/table.ts#L1292
    if (table !== undefined) {
      // table.filterConstraints[CustomTableFilterMatchers.FormattedNumericMatcher] = (value, filter): boolean => {
      //   if (filter === undefined || filter === null || filter.trim() === '') {
      //     return true;
      //   }

      //   if (value === undefined || value === null) {
      //     return false;
      //   }

      //   const formattedDate = this.createNumericLabelPipe.transform(value, false);
      //   const stringValue = ObjectUtils.removeAccents(formattedDate.toString()).toLowerCase();
      //   const filterValue = ObjectUtils.removeAccents(filter.toString()).toLowerCase();

      //   return stringValue.slice(0, filterValue.length) === filterValue;
      // };
    }
  }
}
